// Inline styles (required due to styling of Material UI)
// Incoming msg styles
export const styleIncomingMsg: React.CSSProperties = {
  backgroundColor: '#f5f5ff',
  color: '#323444',
  float: 'left',
  boxShadow: '0px 0px 4px rgba(50, 52, 68, 0.15)',
  borderRadius: '2px 14px 14px 14px',
};

export const styleIncomingTimeLbl: React.CSSProperties = {
  color: '#323444',
  fontWeight: 300,
};

export const styleOutgoingMsg: React.CSSProperties = {
  backgroundColor: '#323444',
  color: '#FFFFFF',
  float: 'right',
  boxShadow: '0px 0px 4px rgba(50, 52, 68, 0.15)',
  borderRadius: '14px 2px 14px 14px',
};

export const styleOutgoingTimeLbl: React.CSSProperties = {
  color: '#FFFFFF',
};

export const styleQuotedOutgoingMsg: React.CSSProperties = {
  ...styleOutgoingMsg,
  float: 'none',
  marginBottom: '10px',
};

export const styleFailedDlvrMsg: React.CSSProperties = {
  backgroundColor: 'rgba(211, 47, 47, 0.48)',
  color: '#FFFFFF',
  minWidth: '12.5em',
};
